// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as fetchGetStuInfoReducer } from './fetchGetStuInfo';
import { reducer as fetchGetMyCourseReducer } from './fetchGetMyCourse';
import { reducer as fetchGetMyQuestionReducer } from './fetchGetMyQuestion';
import { reducer as fetchGetNotificationReducer } from './fetchGetNotification';
import { reducer as fetchGetWaitPayReducer } from './fetchGetWaitPay';
import { reducer as fetchGetMyInterlocutionReducer } from './fetchGetMyInterlocution';
import { reducer as fetchDelMyInterIocutionReducer } from './fetchDelMyInterIocution';
import { reducer as fetchGetMyInterIocutionCountReducer } from './fetchGetMyInterIocutionCount';
import { reducer as fetchGetMyCommentReducer } from './fetchGetMyComment';
import { reducer as fetchGetMyCollectReducer } from './fetchGetMyCollect';
import { reducer as fetchGetIsOrderReducer } from './fetchGetIsOrder';
import { reducer as fetchCancelCollectionReducer } from './fetchCancelCollection';
import { reducer as fetchGetLookInfoReducer } from './fetchGetLookInfo';
import { reducer as fetchGetAllSubjectReducer } from './fetchGetAllSubject';
import { reducer as fetchGetQuestionStoreReducer } from './fetchGetQuestionStore';
import { reducer as updateQuestionStoreReducer } from './updateQuestionStore';
import { reducer as fetchGetChapterReducer } from './fetchGetChapter';
import { reducer as fetchGetChapterPraticeInfoReducer } from './fetchGetChapterPraticeInfo';
import { reducer as fetchGetExamPaperListReducer } from './fetchGetExamPaperList';
import { reducer as fetchAddCollectonReducer } from './fetchAddCollecton';
import { reducer as fetchGetStudentPraticeListReducer } from './fetchGetStudentPraticeList';
import { reducer as fetchGetQuestionTypeListReducer } from './fetchGetQuestionTypeList';
import { reducer as fetchGetCollectionListReducer } from './fetchGetCollectionList';
import { reducer as fetchGetCollectionExamListReducer } from './fetchGetCollectionExamList';
import { reducer as fetchGetMyWrongQuestionReducer } from './fetchGetMyWrongQuestion';
import { reducer as fetchGetMyNoteReducer } from './fetchGetMyNote';
import { reducer as fetchAddQuestionNoteReducer } from './fetchAddQuestionNote';
import { reducer as fetchAddQuestionerrorCorrectionReducer } from './fetchAddQuestionerrorCorrection';
import { reducer as fetchDeleteNoteByIdReducer } from './fetchDeleteNoteById';
import { reducer as fetchGetQuestionerrorCorrectionListReducer } from './fetchGetQuestionerrorCorrectionList';
import { reducer as fetchUpdateHeadPicReducer } from './fetchUpdateHeadPic';
import { reducer as fetchGetMyOrderReducer } from './fetchGetMyOrder';
import { reducer as fetchDeleteOrderReducer } from './fetchDeleteOrder';
import { reducer as fetchCancelOrderReducer } from './fetchCancelOrder';
import { reducer as fetchRefundReducer } from './fetchRefund';
import { reducer as fetchGetNationListReducer } from './fetchGetNationList';
import { reducer as fetchGetProvincesReducer } from './fetchGetProvinces';
import { reducer as fetchGetHDictionaryListReducer } from './fetchGetHDictionaryList';
import { reducer as fetchGetCitysReducer } from './fetchGetCitys';
import { reducer as fetchGetDistrictsReducer } from './fetchGetDistricts';
import { reducer as fetchEditStudentReducer } from './fetchEditStudent';
import { reducer as fetchEditStuPwdReducer } from './fetchEditStuPwd';
import { reducer as fetchGetStuInfoCodeReducer } from './fetchGetStuInfoCode';
import { reducer as fetchEditStuInfoPhoneReducer } from './fetchEditStuInfoPhone';
import { reducer as fetchDeleteMyCorrectionReducer } from './fetchDeleteMyCorrection';
import { reducer as fetchGetMycenterAdReducer } from './fetchGetMycenterAd';
import { reducer as fetchCheckGuideReducer } from './fetchCheckGuide';
import { reducer as fetchGuideCompelteReducer } from './fetchGuideCompelte';
import { reducer as fetchNoLoginInputToShopcarReducer } from './fetchNoLoginInputToShopcar';
import { reducer as fetchGetProvinceListReducer } from './fetchGetProvinceList';
import { reducer as fetchMyCouponListReducer } from './fetchMyCouponList';
import { reducer as fetchGetCanUseCouponReducer } from './fetchGetCanUseCoupon';
import { reducer as fetchGetPublicAccountReducer } from './fetchGetPublicAccount';
import { reducer as fetchGetDefaultWxImgReducer } from './fetchGetDefaultWxImg';

const reducers = [
  fetchGetStuInfoReducer,
  fetchGetMyCourseReducer,
  fetchGetMyQuestionReducer,
  fetchGetNotificationReducer,
  fetchGetWaitPayReducer,
  fetchGetMyInterlocutionReducer,
  fetchDelMyInterIocutionReducer,
  fetchGetMyInterIocutionCountReducer,
  fetchGetMyCommentReducer,
  fetchGetMyCollectReducer,
  fetchGetIsOrderReducer,
  fetchCancelCollectionReducer,
  fetchGetLookInfoReducer,
  fetchGetAllSubjectReducer,
  fetchGetQuestionStoreReducer,
  updateQuestionStoreReducer,
  fetchGetChapterReducer,
  fetchGetChapterPraticeInfoReducer,
  fetchGetExamPaperListReducer,
  fetchAddCollectonReducer,
  fetchGetStudentPraticeListReducer,
  fetchGetQuestionTypeListReducer,
  fetchGetCollectionListReducer,
  fetchGetCollectionExamListReducer,
  fetchGetMyWrongQuestionReducer,
  fetchGetMyNoteReducer,
  fetchAddQuestionNoteReducer,
  fetchAddQuestionerrorCorrectionReducer,
  fetchDeleteNoteByIdReducer,
  fetchGetQuestionerrorCorrectionListReducer,
  fetchUpdateHeadPicReducer,
  fetchGetMyOrderReducer,
  fetchDeleteOrderReducer,
  fetchCancelOrderReducer,
  fetchRefundReducer,
  fetchGetNationListReducer,
  fetchGetProvincesReducer,
  fetchGetHDictionaryListReducer,
  fetchGetCitysReducer,
  fetchGetDistrictsReducer,
  fetchEditStudentReducer,
  fetchEditStuPwdReducer,
  fetchGetStuInfoCodeReducer,
  fetchEditStuInfoPhoneReducer,
  fetchDeleteMyCorrectionReducer,
  fetchGetMycenterAdReducer,
  fetchCheckGuideReducer,
  fetchGuideCompelteReducer,
  fetchNoLoginInputToShopcarReducer,
  fetchGetProvinceListReducer,
  fetchMyCouponListReducer,
  fetchGetCanUseCouponReducer,
  fetchGetPublicAccountReducer,
  fetchGetDefaultWxImgReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/center/redux/reducer.js